module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="apexchat_question_type_file livechat_rd_fade_in_bottom_delay apexchat_qt_button_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'"\r\n     tabindex="0" id="apexchat_question_type_parent_file_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" style="' +
((__t = (styles )) == null ? '' : __t) +
' ">\r\n    <label class="apexchat_question_type_file_label" for="apexchat_scripts_radio_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'">\r\n        <div class="apexchat_question_type_file" id="apexchat_question_type_file_label_' +
((__t = (messageId )) == null ? '' : __t) +
'_' +
((__t = (id )) == null ? '' : __t) +
'" style="' +
((__t = (fontStyle )) == null ? '' : __t) +
' ">\r\n            <div class="apexchat_file_wrapper">\r\n                <a class="apexchat_file_link ';
 if(isUnviewable){ ;
__p += ' apexchat_file_unviewable';
 } ;
__p += '" href="#" src="' +
((__t = (url )) == null ? '' : __t) +
'" data-id="' +
((__t = (id )) == null ? '' : __t) +
'" data-msgid="' +
((__t = (messageId )) == null ? '' : __t) +
'">\r\n                    <span class="apexchat_file_icon">\r\n                        <img src="https://d3b4i635mede5k.cloudfront.net/file-' +
((__t = (type )) == null ? '' : __t) +
'.svg" alt="' +
((__t = (type )) == null ? '' : __t) +
'">\r\n                    </span>\r\n                    <span class="apexchat_file_description">\r\n                        <span class="description">\r\n                            ' +
((__t = ( name )) == null ? '' : __t) +
'\r\n                        </span>\r\n                        <span class="file_size">' +
((__t = ( size )) == null ? '' : __t) +
'</span>\r\n                    </span>\r\n                </a>\r\n                <span class="apexchat_file_download" data-id="' +
((__t = (id )) == null ? '' : __t) +
'" data-msgid="' +
((__t = (messageId )) == null ? '' : __t) +
'">\r\n                    <a href="' +
((__t = (url )) == null ? '' : __t) +
'" target="_blank">\r\n                        <img src="https://d3b4i635mede5k.cloudfront.net/download-icon.svg" alt="Download">\r\n                    </a>\r\n                </span>\r\n            </div>\r\n            <div class="livechat_unsupported_file_info">\r\n                <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.8 27.8">\r\n                    <path style="fill: #656565" d="M25.93,6.95c2.48,4.3,2.48,9.6,0,13.9-2.48,4.3-7.07,6.95-12.04,6.95s-9.55-2.65-12.04-6.95C-.62,16.55-.62,11.25,1.86,6.95,4.34,2.65,8.93,0,13.9,0s9.55,2.65,12.04,6.95Zm-12.04,0c-.96,0-1.74,.78-1.74,1.74s.78,1.74,1.74,1.74,1.74-.78,1.74-1.74-.78-1.74-1.74-1.74Zm1.3,12.6v-6.08c0-.72-.58-1.3-1.3-1.3s-1.3,.58-1.3,1.3v6.08c0,.72,.58,1.3,1.3,1.3s1.3-.58,1.3-1.3Z"></path>\r\n                </svg>\r\n                <span>This file format isn\'t compatible for preview in your browser. Please \'Download\' to view.</span>\r\n            </div>\r\n    </label>\r\n</div>\r\n\r\n';

}
return __p
}